module.exports = __webpack_public_path__ + "img/trash-red.f29425bc.svg";